import Navbar from "./Navbar";

const Layout = ({ children }) => (
  <>
    <Navbar />
    <main className="pt-20"> {children}</main>
  </>
);

export default Layout;
